import { STATIC_CDN_URL } from '../../config';
/**
 * Get the full URL for an image.
 * If the URL starts with 'http://' or 'https://', it returns the URL as is.
 * Otherwise, it prepends the STATIC_CDN_URL to the image path.
 * @param val
 * @returns
 */
export function getImageUrl(val: string): string | null {
    if (!val) return null;
    if (val.startsWith('http://') || val.startsWith('https://')) {
        return val;
    }
    return `${STATIC_CDN_URL}${val.startsWith('/') ? '' : '/'}${val}`;
}
